function checkElementInView(selector, inViewCallback, outOfViewCallback, customConfig) {
    var elements;

    if (typeof selector === "string") {
        elements = document.querySelectorAll(selector);
    } else if (typeof selector === "object") {
        if (selector.length) {
            elements = selector;
        } else {
            elements = [selector];
        }
    } else {
        return;
    }

    var defaultConfig = {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0]
    };

    var config = Object.assign({}, defaultConfig, customConfig || {});

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                inViewCallback(entry.target);
            } else {
                outOfViewCallback(entry.target);
            }
        });
    }, config);

    Array.prototype.forEach.call(elements, function (element) {
        observer.observe(element);
    });

    return observer;
}
